var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { TextField } from '@doordash/component-fields';
import { AnchoredLayer } from '@doordash/component-layer-manager';
import styled from 'styled-components';
import { FilteredOptions, } from '../../../components/filtered_options';
export var SearchableOptionsContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width;
});
export var SearchableOptionsInTextField = function (_a) {
    var label = _a.label, name = _a.name, isLabelHidden = _a.isLabelHidden, placeholder = _a.placeholder, textFieldValue = _a.textFieldValue, options = _a.options, isLoading = _a.isLoading, onSelectOption = _a.onSelectOption, setTextFieldValue = _a.setTextFieldValue, _b = _a.width, width = _b === void 0 ? '500px' : _b;
    var handleSelectOption = function (option) {
        focusTextFieldEl();
        onSelectOption(option);
    };
    var focusTextFieldEl = function () {
        var _a;
        var textField = document.querySelector("textarea[data-anchor-id=\"" + name + "\"]");
        (_a = textField === null || textField === void 0 ? void 0 : textField.focus) === null || _a === void 0 ? void 0 : _a.call(textField);
    };
    return (React.createElement(SearchableOptionsContainer, { width: width },
        React.createElement(AnchoredLayer, { shouldAutomaticallyFlip: false, position: AnchoredLayer.Positions.BottomCenter, content: !isLoading &&
                !!(options === null || options === void 0 ? void 0 : options.length) && (React.createElement(FilteredOptions, { width: width, options: options, onSelect: handleSelectOption })) },
            React.createElement(TextField, { "data-anchor-id": name, name: name, label: label, isLabelHidden: isLabelHidden, placeholder: placeholder, isRequired: true, autoComplete: "off", onChange: setTextFieldValue, value: textFieldValue, isMultiline: 5, autoFocus: true }))));
};
var templateObject_1;
